import { render } from "./TkBadge.vue?vue&type=template&id=656ab42d"
import script from "./TkBadge.vue?vue&type=script&lang=js"
export * from "./TkBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__